import { useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { useI18n } from '@/i18n'
import { Banner, BilingualLabel } from '@/ui'
import { CountFlow } from '../components/CountFlow'
import { StoreScreen } from '../components/StoreScreen'

/** F5.6 — Count a place: scan the label, then every tag there; count_bay. Torn / tagless → F5-B1. */
export function CountPage() {
  const { t } = useI18n()
  const [params] = useSearchParams()
  const [result, setResult] = useState<{ count_id: string; location_id: string } | null>(null)
  return (
    <StoreScreen title="store.count">
      {(state) =>
        result ? (
          <div className="flex flex-col gap-3">
            <Banner tone="success" title={t('store.count.sent')}>
              {t('store.count.sentBody')}
            </Banner>
            <Link
              to={`/m/store/replace?location=${encodeURIComponent(result.location_id)}&count=${encodeURIComponent(result.count_id)}`}
              className="inline-flex min-h-touch-lg items-center justify-center rounded-chip border border-danger px-6 font-mono text-[14px] font-bold uppercase tracking-label text-danger"
            >
              <BilingualLabel k="store.replace.title" />
            </Link>
            <Link
              to="/m"
              className="inline-flex min-h-touch-lg items-center justify-center rounded-chip border border-ink bg-ink px-6 font-mono text-[14px] font-bold uppercase tracking-label text-paper"
            >
              {t('common.done')}
            </Link>
          </div>
        ) : (
          <CountFlow
            state={state}
            initialLocationId={params.get('location')}
            onCounted={setResult}
          />
        )
      }
    </StoreScreen>
  )
}
